import themePreset from '@wippy-fe/theme/tailwind.config'

/** @type {import('tailwindcss').Config} */
export default {
  presets: [themePreset],
  content: [
    './index.html',
    './src/**/*.{vue,ts}',
  ],
}
